/* tslint:disable */
/* eslint-disable */
export enum SolutionEnum {
  VituPay = 'VituPay',
  Dealer = 'Dealer'
}
